import { Outlet } from "react-router-dom";

function PlainLayout() {
  return <Outlet />;
}

export default PlainLayout;